import { Page } from '@/typings/page';
import useCurrentPage from '@/hooks/useCurrentPage';

import { FinanceLanding } from './types';

export function useFinanceLandingData(): Page<FinanceLanding>['templateFields'] {
  return useCurrentPage<Page<FinanceLanding>>().templateFields;
}
